import { useEffect, useState } from "react";
import { Trash2, Copy, Mail } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

export default function AdminSubscribers() {
  const [subs, setSubs] = useState([]);

  const load = () => api.get("/subscribers").then((r) => setSubs(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    await api.delete(`/subscribers/${id}`);
    load();
  };

  const copyAll = () => {
    const text = subs.map((s) => s.email).join(", ");
    navigator.clipboard.writeText(text);
    toast.success("All emails copied to clipboard");
  };

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-display font-semibold text-lg text-[#1A231C]">Stock Alert Subscribers</h3>
          <p className="text-sm text-[#5C665D]">{subs.length} subscriber{subs.length === 1 ? "" : "s"} collected from the footer signup.</p>
        </div>
        {subs.length > 0 && (
          <button data-testid="subscribers-copy" onClick={copyAll} className="inline-flex items-center gap-2 bg-[#F4EFE6] text-[#1A231C] px-3 py-2 rounded-lg text-sm hover:bg-[#E8E4D9]">
            <Copy className="w-4 h-4" /> Copy all
          </button>
        )}
      </div>

      {subs.length === 0 ? (
        <div className="bg-white border border-[#E8E4D9] rounded-xl p-12 text-center">
          <Mail className="w-12 h-12 text-[#E8E4D9] mx-auto" strokeWidth={1.5} />
          <p className="text-[#5C665D] mt-4">No subscribers yet. They'll appear here when customers sign up in the footer.</p>
        </div>
      ) : (
        <div className="bg-white border border-[#E8E4D9] rounded-xl divide-y divide-[#E8E4D9]">
          {subs.map((s) => (
            <div key={s.id} data-testid={`subscriber-${s.id}`} className="flex items-center justify-between px-4 py-3">
              <div>
                <p className="text-[#1A231C]">{s.email}</p>
                <p className="text-xs text-[#5C665D]">{new Date(s.created_at).toLocaleString()}</p>
              </div>
              <button data-testid={`subscriber-delete-${s.id}`} onClick={() => del(s.id)} className="text-[var(--brand-accent)] p-1.5 rounded hover:bg-[#F4EFE6]">
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
